import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const projectApiUrl = `${baseApiUrl}/api/Project`;

export async function getProjects() {
    return await httpRequest(fetchProject.bind(this));
}

async function fetchProject() {
    let config = getHttpHeaders();
    return await axios.get(`${projectApiUrl}`, config);
}

export async function getProjectById(id) {
    return await httpRequest(fetchProjectById.bind(this, id));
}

async function fetchProjectById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${projectApiUrl}/${id}`, config);
}

export async function updateProject(project) {
    return await httpRequest(putProject.bind(this, project));
}

async function putProject(project) {
    let config = getHttpHeaders();
    return await axios.put(`${projectApiUrl}`, project, config);
}

export async function addProject(newproject) {
    return await httpRequest(postProject.bind(this, newproject));
}

async function postProject(newproject) {
    let config = getHttpHeaders();
    return await axios.post(`${projectApiUrl}`, newproject, config);
}

export async function deleteProject(id) {
    return await httpRequest(fetchDeleteProject.bind(this, id));
}

async function fetchDeleteProject(id) {
    let config = getHttpHeaders();
    return await axios.delete(`${projectApiUrl}/${id}`, config);
}
